import marked from 'marked';

marked.setOptions({
  breaks: true,
  sanitize: true,
});

export default marked;
